import React from 'react';
import { bool, func } from 'prop-types';
import { UTLabel } from '@widergy/energy-ui';

import UTModal from '../../../../../../components/UTModal';
import { appConfig } from '../../../../../../../config/customization';
import { message } from '../../../../../../../utils/stringUtils';

import styles from './style';

class RelatedSuppliesModal extends React.Component {
  handleAccept = () => {
    this.props.onRelatedSuppliesModalClose();
  };

  render() {
    return this.props.relatedSuppliesModalIsOpen && appConfig.addSupplies ? (
      <div>
        <UTModal
          isOpen={this.props.relatedSuppliesModalIsOpen}
          onRequestClose={this.props.onRelatedSuppliesModalClose}
          title={message('Accounts:relatedAccounts')}
          acceptButton={{
            text: message('Commons:accept'),
            onPress: this.handleAccept
          }}
        >
          <div style={styles.suppliesInfo}>
            <UTLabel>{message('Accounts:relatedSuppliesInformation')}</UTLabel>
          </div>
        </UTModal>
      </div>
    ) : null;
  }
}

RelatedSuppliesModal.propTypes = {
  relatedSuppliesModalIsOpen: bool,
  onRelatedSuppliesModalClose: func
};

export default RelatedSuppliesModal;
